<div class="page">
  <app-simplified-header style="width: 100%"></app-simplified-header>
  <section class="content">
    <div class="terms-of-service-container">
      <div class="terms-of-service">
        <h2>Termini di Servizio</h2>
        <div class="terms-of-service-content" [innerHTML]="policyContent"></div>
      </div>
    </div>
  </section>
</div>
